import React, { Component } from 'react';
import styled from 'styled-components';
import BarGraph from '../../../../components/Charts/BarGraph';
import Select from '../../../../components/Select';
import get from 'lodash/get';
import { I18n } from 'react-redux-i18n';

const StackGraphContainer = styled.div`
  .selectSetsContainer {
    margin-top: 50px;
    width: 80%;
    margin-left: 10%;
  }
`;

const Tooltip = styled.div`
  width: 200px;

  .title {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 12px;
    text-transform: uppercase;
    color: #adb5bd;
    margin-bottom: 15px;
    margin-top: 20px;
    margin-left: 20px;
  }

  .row {
    display: flex;
    flex-direction: row;
    width: calc(100% - 40px);
    align-items: center;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-left: 20px;
    margin-right: 20px;
  }

  .rowLabel {
    font-family: ${(props) => props.theme.fonts.sfcompact};
    font-size: 12px;
    color: #4b4b4b;
  }

  .rowValue {
    font-family: ${(props) => props.theme.fonts.sfcompact_bold};
    font-size: 12px;
    color: #4b4b4b;
    margin-left: auto;
  }

  .totalContainer {
    background-color: ${(props) => props.theme.colors.dark};
    color: white;
    font-family: ${(props) => props.theme.fonts.sfcompact_bold};
    font-size: 12px;
    display: flex;
    flex-direction: row;
    width: calc(100% - 40px);
    align-items: center;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .totalValue {
    margin-left: auto;
  }
`;

const TickContainer = styled.text`
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  fill: #2b3d54;
  font-size: 12px;
  fill: ${(props) =>
    props.hovering
      ? props.isHover
        ? '#e25d34'
        : '#c2c8ce'
      : props.theme.colors.dark};
`;

class StackGraph extends Component {
  constructor(props) {
    super(props);
    this.state = { hoveredWine: null };
  }

  renderTickAxis({ x, y, payload }) {
    const { hoveredWine } = this.state;
    const valueFormatted =
      payload.value && payload.value.length > 7
        ? payload.value.substring(0, 7) + '...'
        : payload.value;
    return (
      <TickContainer
        hovering={hoveredWine}
        isHover={hoveredWine == payload.value}
        x={x - valueFormatted.length * 3}
        y={y + 15}
      >
        {valueFormatted}
      </TickContainer>
    );
  }

  getLabels(data) {
    if (data && data.length > 0) {
      return data.map((set) =>
        set && set.length > 0 ? set[0].store_name : ''
      );
    }
    return [];
  }

  renderTooltip(hoverData, unity, currency) {
    const { hoveredWine } = this.state;
    if (hoveredWine !== get(hoverData, '[0].name')) {
      this.setState({ hoveredWine: get(hoverData, '[0].name') });
    }
    const total = hoverData
      .filter((item) => item && item.value)
      .map((item) => item.value)
      .reduce((acc, base) => acc + base);
    return (
      <Tooltip>
        <h3 className="title">
          {I18n.t('auction.auction.valueVolume.salesOf')}{' '}
          {get(hoverData, '[0].name')}
        </h3>
        {hoverData
          .filter((item) => item && item)
          .map((item) => (
            <div key={item.store_name + item.value} className="row">
              <p className="rowLabel">{item.store_name}</p>
              <p className="rowValue">
                {unity
                  ? Number(item.value).toFixed(0) + ' bt.'
                  : Number(item.value).toLocaleString('fr-FR', {
                      style: 'currency',
                      currency: currency,
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 1
                    })}{' '}
                {unity}
              </p>
            </div>
          ))}
        <div className="totalContainer">
          <p>Total</p>
          <p className="totalValue">
            {unity
              ? Number(total).toFixed(0) + ' bt.'
              : Number(total).toLocaleString('fr-FR', {
                  style: 'currency',
                  currency: currency,
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 1
                })}{' '}
          </p>
        </div>
      </Tooltip>
    );
  }

  renderSelectSets() {
    const {
      rivalOptions = [],
      selectedRivals = [],
      onChangeRivals
    } = this.props;

    return (
      <div className="selectSetsContainer ignored-export">
        <Select
          placeholder={I18n.t('placeholderRivals')}
          isMulti
          value={selectedRivals}
          dropdownProps={{
            styles: `margin-left:20px;margin-right:20px;`
          }}
          onChange={(value) => onChangeRivals(value)}
          options={rivalOptions}
        />
      </div>
    );
  }

  render() {
    const { data, unity, currency = 'EUR' } = this.props;
    const labels = this.getLabels(data);

    return (
      <StackGraphContainer>
        <BarGraph
          data={data}
          height={450}
          isStacked
          yAxisProps={{
            width: 70,
            tickFormatter: (value) =>
              value.toLocaleString('fr-FR', {
                style: unity ? undefined : 'currency',
                currency: unity ? undefined : currency,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              })
          }}
          xAxisProps={{
            minTickGap: -20,
            tick: (props) =>
              this.renderTickAxis({
                ...props
              })
          }}
          tooltipOffset={{ x: 85, y: data.length * -20 }}
          tooltipOffsetRight={{ x: 20, y: data.length * -20 }}
          tooltipOffsetLeft={{ x: 160, y: data.length * -20 }}
          renderTooltip={(hoverData) =>
            this.renderTooltip(hoverData, unity, currency)
          }
          cancelControlledHover={() => this.setState({ hoveredWine: null })}
          labels={labels}
          hoverAsBorder
          colorArrow={{ Top: '#293442' }}
          customColors={['#293442', '#525d69', '#79838c', '#a4abae', '#d0d4d3']}
        />

        {this.renderSelectSets()}
      </StackGraphContainer>
    );
  }
}

export default StackGraph;
